import CarrierList from './List';
import CarrierForm from './Form';


export default {
    path: 'cadastros',
    redirect: '/cadastros/operadoras',
    name: 'Cadastro Operadoras',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'operadoras',
            name: 'list-carrier',
            component: CarrierList,
            meta: {
                requiresAuth: true,
                label: 'Listar Operadoras'
            }
        },
        {
            path: 'operadoras/novo',
            name: 'new-carrier',
            component: CarrierForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Operadora'
            }
        },
        {
            path: 'operadoras/:id',
            name: 'edit-carrier',
            component: CarrierForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Operadora'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/carrier/router.js